import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { Label } from "@/components/ui/label"
import { cn } from "@/lib/utils"

export const RadioGroup = ({ className, ...props }: React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Root>) => {
  return <RadioGroupPrimitive.Root className={cn("radio-group grid gap-2", className)} {...props} />
}

interface RadioGroupItemProps extends React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Item> {
  error?: boolean
}

export const RadioGroupItem = ({ className, children, error, ...props }: RadioGroupItemProps) => {
  return (
    <RadioGroupPrimitive.Item
      {...props}
      className={cn(
        "radio-item ring-offset-background focus-visible:outline-primary-focused flex h-8 cursor-pointer items-center gap-2 self-center rounded-md border pr-3 pl-1.5 focus:outline-hidden",
        error && "radio-item--error",
        className,
      )}>
      <div className="radio-check relative">
        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 20.25C10.3683 20.25 8.77326 19.7661 7.41655 18.8596C6.05984 17.9531 5.00242 16.6646 4.378 15.1571C3.75358 13.6496 3.5902 11.9908 3.90853 10.3905C4.22685 8.79016 5.01259 7.32015 6.16637 6.16637C7.32016 5.01259 8.79017 4.22685 10.3905 3.90852C11.9909 3.59019 13.6497 3.75357 15.1571 4.37799C16.6646 5.00242 17.9531 6.05984 18.8596 7.41655C19.7661 8.77325 20.25 10.3683 20.25 12C20.2475 14.1873 19.3775 16.2843 17.8309 17.8309C16.2843 19.3775 14.1873 20.2475 12 20.25Z" />
        </svg>
        <RadioGroupPrimitive.Indicator asChild className="radio-indicator flex items-center justify-center">
          <span className="bg-primary absolute top-[50%] left-[50%] h-3 w-3 rounded-full" />
        </RadioGroupPrimitive.Indicator>
      </div>
      {children}
    </RadioGroupPrimitive.Item>
  )
}

export const RadioGroupLabel = ({ className, ...props }: React.ComponentPropsWithRef<typeof Label>) => {
  return <Label className={cn("radio-label cursor-[inherit] pr-1.5 leading-5", className)} {...props} />
}
